<template>
  <div v-if="show">
    <show-p-d-f-item
      ref="pdfItem"
      :show="showPdfItem"
      :consent-needed="true"
      consent-text="I have read and agreed with the terms and conditions."
      @onContinue="onConditionsViewed"
      ></show-p-d-f-item>

    <div
      v-if="!showPdfItem"
      class="esign-conditions-container">
      <div class="margin-top-10">
        <weex-text class="item-bold-heading">Terms And Conditions</weex-text>
      </div>

      <div
        v-if="getLenderLogoUrl"
        style="width: 200px"
        class="item-align-right item-row-alignment-baseline margin-top-10">
        <weex-text class="font-weight-bold font-size-sm-base margin-right-5">Powered By</weex-text>

        <weex-image
          :src="getLenderLogoUrl"
          style="width: 108px; height: 30px"
          ></weex-image>
      </div>

      <div class="item-row-alignment-center margin_top_20">
        <weex-text class="font-size-sm-base font-weight-bold">Name&nbsp;:&nbsp;</weex-text>
        <weex-text class="font-size-sm-base">{{getCamelCaseName}}</weex-text>
      </div>
      <div class="item-row-alignment-center margin-top-10">
        <weex-text class="font-size-sm-base font-weight-bold">Phone&nbsp;:&nbsp;</weex-text>
        <weex-text class="font-size-sm-base">{{getClientMobileNumber}}</weex-text>
      </div>

      <div
        class="margin-top-10 padding-top-10 padding-bottom-10"
        style="background: white"
        v-if="showLoanDetailsSummary">
        <div class="item-row-alignment-center">
          <div class="product-item">
            <weex-text class="font-size-sm-base font-weight-bold">Loan Amount</weex-text>
            <weex-text class="font-size-sm-base">{{getLoanAmount}}</weex-text>
          </div>

          <div class="product-item">
            <weex-text class="font-size-sm-base font-weight-bold">Total EMI Payment</weex-text>
            <weex-text class="font-size-sm-base">{{getTotalEmiPayment}}*</weex-text>
          </div>
        </div>

        <div class="item-row-alignment-center margin-top-10">
          <div class="product-item">
            <weex-text class="font-size-sm-base font-weight-bold">Loan Tenure</weex-text>
            <weex-text class="font-size-sm-base">{{getTenure}} months</weex-text>
          </div>

          <div class="product-item">
            <weex-text class="font-size-sm-base font-weight-bold">Interest Rate</weex-text>
            <weex-text class="font-size-sm-base">{{getInterestRate}} %</weex-text>
          </div>
        </div>

        <div class="item-row-alignment-center margin-top-10">
          <div class="product-item">
            <weex-text class="font-size-sm-base font-weight-bold">First EMI Date</weex-text>
            <weex-text class="font-size-sm-base">{{getFirstEmiDate}}</weex-text>
          </div>

          <div class="product-item">
            <weex-text class="font-size-sm-base font-weight-bold">Monthly Repayment (EMI)
            </weex-text>
            <weex-text class="font-size-sm-base">{{getEMIAmount}}*</weex-text>
          </div>
        </div>
      </div>

      <weex-text
        v-if="showLoanDetailsSummary"
        class="font-size-sm text-color-gray"
        style="font-style: italic">(*) Approximate EMI displayed
      </weex-text>

      <div class="margin_top_20">
        <wxc-button
          v-if="isViewTncBeforeAcceptMandatory"
          class="horizontal_center margin_top_20"
          @wxcButtonClicked="onViewTermsAndConditionsClicked"
          size="big"
          type="blue"
          text="View Application Form and T&Cs"
          ></wxc-button>
        <div v-else>
          <weex-text class="font-weight-bold font-size-sm-base">Terms and Conditions</weex-text>
          <weex-text
            class="font-size-sm-base text-color-gray margin-top-10">You have read and agreed to the
            following
          </weex-text>
        </div>

      </div>


      <div
        v-if="!isViewTncBeforeAcceptMandatory || conditionsViewed"
        class="margin-top-10">
        <div
          class="item-row-alignment"
          @click="onTnCSelected">
          <weex-image
            :src="getTnCCheckboxLink"
            class="ezcred-checkbox-image"
            ></weex-image>

          <weex-text
            class="ezcred-checkbox-text"
            v-html="getTermsAndConditionsMessage"
            ></weex-text>
        </div>

        <weex-text
          class="font-size-sm-base text-color-gray margin_top_20"
          v-html="getSubmitAgreementMessage"
          ></weex-text>

        <wxc-button
          class="margin-top-10 horizontal_center"
          :btnStyle="buttonBackgroundStyle"
          text="Submit Loan Application"
          @wxcButtonClicked="onSubmit"
          ></wxc-button>

        <weex-text
          v-if="error"
          class="font-size-sm-base"
          style="color:#FF0000;">{{error}}
        </weex-text>
      </div>
    </div>
  </div>
</template>

<script>
  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
  import EzUtils from "../../utils/EzUtils";
  import ShowPDFItem from "./ShowPDFItem";

  const RUPEE = "\u20B9";

  export default {
    title: "Terms and conditions",
    components: { WxcButton, ShowPDFItem },
    props: {
      termsAndConditionsViewData: {
        type: Object,
        required: true,
        default: () => ({})
      },

      show: {
        type: Boolean,
        required: true,
        default: false
      },

      showLoanDetailsSummary: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      agreeConditions: false,
      conditionsViewed: false,
      showPdfItem: false,
      error: ""
    }),

    methods: {
      onViewTermsAndConditionsClicked() {
        this.showPdfItem = true;
        this.$refs.pdfItem.showPdfFile(
          EzUtils.getParamFromUrl("url", this.termsAndConditionsViewData.acceptConditionsUrl),
          true
        );
      },

      onConditionsViewed() {
        this.showPdfItem = false;
        this.conditionsViewed = true;
      },

      getFormattedAmount(amount) {
        return RUPEE + " " + amount
      },

      onSubmit() {
        if (this.checkForValidation()) {
          this.$emit("submitTermsAndConditions");
        }
      },

      checkForValidation() {
        if (this.isViewTncBeforeAcceptMandatory && !this.conditionsViewed) {
          this.error = "Please read the Terms and Conditions";
          return false;
        }

        if (!this.agreeConditions) {
          this.error = "Please accept Terms and Conditions";
          return false;
        }

        return true;
      },

      onTnCSelected() {
        this.agreeConditions = !this.agreeConditions;
        if (this.agreeConditions) {
          this.error = ""
        }
      }
    },

    computed: {
      getTnCCheckboxLink() {
        return this.agreeConditions
          ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHECKED_CHECKBOX)
          : ImageResourcesUtil.getImageLink(ImageResourcesUtil.UNCHECKED_CHECKBOX);
      },

      buttonBackgroundStyle() {
        if (this.agreeConditions
          && (this.conditionsViewed || !this.isViewTncBeforeAcceptMandatory)) {
          return { 'background': '#0F8DE8' }
        } else {
          return { 'background': '#808080' }
        }
      },

      getCamelCaseName() {
        return this.termsAndConditionsViewData
          ? EzUtils.toCamelCase(this.termsAndConditionsViewData.clientName)
          : "";
      },

      getClientMobileNumber() {
        return this.termsAndConditionsViewData ? this.termsAndConditionsViewData.clientMobile : "";
      },

      getLoanAmount() {
        return this.termsAndConditionsViewData
          ? this.getFormattedAmount(this.termsAndConditionsViewData.loanAmount)
          : "";
      },

      getEMIAmount() {
        return this.termsAndConditionsViewData
          ? this.getFormattedAmount(this.termsAndConditionsViewData.emiAmount)
          : "";
      },

      getTotalEmiPayment() {
        return this.termsAndConditionsViewData
          ? this.getFormattedAmount(this.termsAndConditionsViewData.totalEmiPayment)
          : "";
      },

      getTenure() {
        return this.termsAndConditionsViewData ? this.termsAndConditionsViewData.tenure : "";
      },

      getInterestRate() {
        return this.termsAndConditionsViewData ? this.termsAndConditionsViewData.interestRate : "";
      },

      getFirstEmiDate() {
        return this.termsAndConditionsViewData ? this.termsAndConditionsViewData.firstEmiDate : "";
      },

      getTermsAndConditionsMessage() {
        return this.termsAndConditionsViewData
          ? this.termsAndConditionsViewData.termsAndConditionsMessage
          : "";
      },

      getSubmitAgreementMessage() {
        return this.termsAndConditionsViewData
          ? this.termsAndConditionsViewData.submitAgreementMessage
          : "";
      },

      getLenderLogoUrl() {
        return this.termsAndConditionsViewData ? this.termsAndConditionsViewData.lenderLogoUrl : "";
      },

      isViewTncBeforeAcceptMandatory() {
        return this.termsAndConditionsViewData
          ? this.termsAndConditionsViewData.viewTncBeforeAcceptMandatory : false;
      }
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>
  .esign-conditions-container {
    margin: 20px auto;
    position: relative;
    background: #F9F9F9;
    padding: 10px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  }

  .product-item {
    width: 50%;
  }
</style>
